// Copyright The Linux Foundation and each contributor to LFX.
// SPDX-License-Identifier: MITs
import { gql } from 'apollo-angular';

export const reviewersCubeQuery = gql`
  query ($organizationId: String!, $dateRange: String!) {
    reviewers(organizationId: $organizationId, dateRange: $dateRange) {
      memberId
      memberUsername
      displayName
      logoUrl
      githubUrl
      twitterUrl
      linkedinUrl
      countCodeReviews
      lastReviewDate
      countReviewersProjects
      countContributions
    }
  }
`;
